<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 확인자 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 확인자</h5>
      <div class="writeGridContainer">
        <div><div>담당</div><ml-input v-model="form.sign1.name" :readonly="board.readonly" /></div>
        <div><div>서명</div><sign-field v-model="form.sign1.sign" :readonly="board.readonly" /></div>
      </div>
      <div class="writeGridContainer">
        <div><div>팀장</div><ml-input v-model="form.sign2.name" :readonly="board.readonly" /></div>
        <div><div>서명</div><sign-field v-model="form.sign2.sign" :readonly="board.readonly" /></div>
      </div>
      <div class="writeGridContainer">
        <div><div>과장</div><ml-input v-model="form.sign3.name" :readonly="board.readonly" /></div>
        <div><div>서명</div><sign-field v-model="form.sign3.sign" :readonly="board.readonly" /></div>
      </div>
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>

import SignField from "@/components/SignField.vue";

export default {
  components: {
    SignField
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>

</style>
